import { Component, DestroyRef, OnInit, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import {
  YdsButtonBackComponent,
  YdsCardComponent,
  YdsEmptyStatesComponent,
  YdsPaginationComponent,
  YdsSpinnerComponent,
  YdsTableComponent,
  type YdsTableColumn,
} from '../../../../yds-angular';
import { JournalProcessLog, JournalprocesslogService } from '../journalprocesslog.service';

const DOWNLOAD_LIST_ROUTE = '/proces/export/exportgeneralledger/downloadgeneralledger';

@Component({
  selector: 'app-journalprocesslog',
  imports: [
    YdsButtonBackComponent,
    YdsCardComponent,
    YdsEmptyStatesComponent,
    YdsPaginationComponent,
    YdsSpinnerComponent,
    YdsTableComponent,
  ],
  templateUrl: './journalprocesslog.component.html',
  styleUrl: './journalprocesslog.component.scss',
})
export class JournalprocesslogComponent implements OnInit {
  readonly pageSize = 100;
  readonly tableColumns: YdsTableColumn[] = [
    { key: 'processStep', header: 'Stap' },
    { key: 'returnCode', header: 'Error code', numeric: true },
    { key: 'rowCount', header: 'Aantal records', numeric: true },
    { key: 'processTime', header: 'Verwerkingstijd', numeric: true },
  ];

  private journalprocesslogService = inject(JournalprocesslogService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);

  private readonly queryParams = this.route.snapshot.queryParamMap;
  private readonly journalPlanningRecordId = this.queryParams.get('journalPlanningRecordId');

  logs = signal<JournalProcessLog[]>([]);
  isLoading = signal(true);
  loadError = signal<string | null>(null);
  pageIndex = signal(0);

  tableItems = computed(() => {
    const start = this.pageIndex() * this.pageSize;
    return this.logs()
      .slice(start, start + this.pageSize)
      .map((item) => ({
        id: item.journalProcessLogId,
        processStep: item.processStep?.trim() ?? '',
        returnCode: item.returnCode,
        rowCount: item.rowCount,
        processTime: item.processTime,
      }));
  });

  ngOnInit(): void {
    if (!this.journalPlanningRecordId) {
      this.isLoading.set(false);
      this.router.navigate([DOWNLOAD_LIST_ROUTE]);
      return;
    }

    this.journalprocesslogService
      .getByJournalPlanningRecord(this.journalPlanningRecordId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result) => {
          this.logs.set(result);
          this.pageIndex.set(0);
          this.isLoading.set(false);
        },
        error: () => {
          this.loadError.set('Verwerkingslog laden mislukt.');
          this.isLoading.set(false);
        },
      });
  }

  onBack(): void {
    this.router.navigate([DOWNLOAD_LIST_ROUTE], {
      queryParams: {
        opdrachtgeverId: this.queryParams.get('opdrachtgeverId'),
        institutionId: this.queryParams.get('institutionId'),
        bookingYear: this.queryParams.get('bookingYear'),
        bookingPeriod: this.queryParams.get('bookingPeriod'),
        pageIndex: this.queryParams.get('pageIndex'),
      },
    });
  }
}
